import React, { Component } from 'react';
import { HttpRequestService } from '../../services/HttpRequestService';
import moment from 'moment'
import DatePicker from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css";
import { UtilsService } from '../../services/UtilsService';
import CompanySelect from '../../common/CompanySelect';

class GravityExport extends Component {

    constructor(props) {
        super(props);
        this.utils = new UtilsService();
        this.state = {
            beginDate: moment().toDate(),
            companyId: 2
        }

        this.http = new HttpRequestService();
        this.handleBeginDateChange = this.handleBeginDateChange.bind(this);
        this.handleCompanyChange = this.handleCompanyChange.bind(this);
        this.export = this.export.bind(this);
    }

    handleBeginDateChange(e) {
        this.setState({ beginDate: e });
    }

    handleCompanyChange(companyId) {
        this.setState({ companyId: companyId });
    }

    export(e) {
        e.preventDefault();
        var params = {
            beginDate: this.state.beginDate != null ? moment(this.state.beginDate).format('L') : "",
            companyId: this.state.companyId,
        }
        this.http.get('/api/Invoice/ExportToGravity', params).then(data => {
            this.utils.info("The process has been started. It will take some time for the invoices to be transferred to Gravity.");
        });
    }

    render() {
        return (
            <div className="page-inner">
                <div className="page-header">
                    <h4 className="page-title">Export Gravity Data</h4>
                </div>
                <div className="row">
                    <div className="col-md-12">
                        <div className="card">
                            <div className="card-body">
                                <form onSubmit={this.export}>
                                    <div className="form-row">
                                        <div className="form-group col-md-3">
                                            <label htmlFor="beginDate">Begin Date</label>
                                            <DatePicker className="form-control" selected={this.state.beginDate} onChange={this.handleBeginDateChange} />
                                        </div>
                                        <div className="form-group col-md-3">
                                            <label>Company</label>
                                            <CompanySelect value={this.state.companyId} onChange={this.handleCompanyChange}>
                                            </CompanySelect>
                                        </div>
                                        <div className="form-group col-md-3 mt-4">
                                            <button type="submit" className="btn btn-primary">Export</button>
                                        </div>
                                    </div>
                                </form>
                            </div>

                        </div>
                    </div>
                </div>
            </div>
        );
    }
}

export default GravityExport;
